import { RootState } from '@/store/store';
import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { Api } from '@/api/api';
import { Employee } from "@/domain/employee";

/**
 * Employee store
 */
export interface EmployeeState {
  employees: Employee[];
  employeeToEdit: Employee | undefined;
}

export const state: EmployeeState = {
  employees: [],
  employeeToEdit: undefined
};

export const getters: GetterTree<EmployeeState, RootState> = {
  getAllEmployees: state => state.employees,
  getEmployeeToEdit: state => state.employeeToEdit
};

export const mutations: MutationTree<EmployeeState> = {
  SET_EMPLOYEES: (state, employees) => state.employees = employees,
  SET_EMPLOYEE_TO_EDIT: (state, employee) => state.employeeToEdit = employee
};

export const actions: ActionTree<EmployeeState, RootState> = {
  FETCH_EMPLOYEES({ commit }) {
    return Api.Employee.getEmployees().then(response => {
      commit('SET_EMPLOYEES', response.employees)
    });
  },
  SYNC_EMPLOYEES_WITH_AZURE_AD({ commit }) {
    return Api.Employee.syncEmployeesWithAzureAD().then(response => {
      commit('SET_EMPLOYEES', response.employees)
    });
  },
  async UPDATE_EMPLOYEE({ commit }, updatedEmployee : Employee) {
    return await Api.Employee.updateEmployee(updatedEmployee);
  }
};

export const EmployeeStore: Module<EmployeeState, RootState> = {
  state,
  getters,
  mutations,
  actions
};
